import axios from "../network/reuset";
import qs from "qs";

const getApp = {
  getAppList(params) {
    return axios.post(`/api/admin/app/list`, qs.stringify(params));
  },
  postAddApp(params) {
    return axios.post(`/api/admin/app/add`, qs.stringify(params));
  },
  getAppInfo(params) {
    return axios.post(`/api/admin/app/info`, qs.stringify(params));
  },
  postSaveAppInfo(params) {
    return axios.post(`/api/admin/app/save`, qs.stringify(params));
  },
  postSaveAppConfig(params) {
    return axios.post(`/api/admin/app/config/save`, qs.stringify(params));
  },
  postSaveAppStatus(params) {
    return axios.post(`/api/admin/app/save_app_status`, qs.stringify(params));
  },
  postSaveAppInterior(params) {
    return axios.post(`/api/admin/app/save_app_interior`, qs.stringify(params));
  },
  postDeleteApp(params) {
    return axios.post(`/api/admin/app/del`, qs.stringify(params));
  },
  getAppDau(params) {
    return axios.post(`/api/admin/app/data_dau`, qs.stringify(params));
  },
};

export default getApp;
